import React, { FC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Basic, { BasicProps } from './Basic'

export type BrandstoryProps = Omit<BasicProps, 'type' | 'imageWidth'>

const Brandstory: FC<BrandstoryProps> = props => {
    return (
        <>
            <Grid noExpand display={['none', 'none', 'flex']}>
                <Basic type="left" {...props} />
            </Grid>
            <Grid noExpand display={['flex', 'flex', 'none']}>
                <Basic type="top" {...props} imageWidth="100%" />
            </Grid>
        </>
    )
}
export default memo(Brandstory)
